import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "lc_cookie_consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 inset-x-4 md:left-auto md:right-6 md:max-w-md z-[60] rounded-2xl bg-crema border border-rosa/40 shadow-2xl p-6"
    >
      <div className="flex items-start gap-3">
        <Cookie className="h-6 w-6 text-terracota shrink-0 mt-0.5" />
        <div>
          <p className="font-sans font-semibold text-ciruela text-sm">Uso de cookies</p>
          <p className="font-body text-sm text-ciruela-dark/75 mt-1.5 leading-relaxed">
            Utilizo cookies propias y de terceros para mejorar tu experiencia. Puedes aceptarlas o
            consultar la{" "}
            <Link to="/politica-cookies" className="text-terracota underline">política de cookies</Link>.
          </p>
          <div className="flex gap-3 mt-4">
            <button
              data-testid="cookie-accept"
              onClick={() => decide("accepted")}
              className="font-sans text-sm font-medium rounded-full bg-terracota text-crema px-5 py-2 hover:bg-terracota-dark transition-colors"
            >
              Aceptar
            </button>
            <button
              data-testid="cookie-reject"
              onClick={() => decide("rejected")}
              className="font-sans text-sm font-medium rounded-full border border-ciruela/40 text-ciruela px-5 py-2 hover:bg-ciruela/10 transition-colors"
            >
              Rechazar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
